import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const AdminInboxQuery = graphql.persisted(
  "AdminInboxQuery",
  graphql(`
    query AdminInboxQuery($schoolYearId: ID!, $date: ISO8601Date, $time: String) {
      schoolYear(id: $schoolYearId) {
        id
        name
        slug
        state
        startDate
        endDate
        school {
          id
          checklistEnrollmentOn
        }
        adminInbox(date: $date, time: $time) {
          generatedAt
          items {
            kind
            title
            detail
            since
            urgency
            amountCents
            count
            familyEnrollment {
              id
              state
              enrollmentKind
              family {
                id
                name
                slug
              }
            }
            family {
              id
              name
              slug
            }
          }
          pipeline {
            setup
            open
            inReview
            offered
            complete
            closed
            enrolledStudents
          }
        }
      }
    }
  `)
);

export { AdminInboxQuery };

/** The viewer's local calendar date and wall-clock time, so "today" is the school's day, not UTC's. */
export function localDateAndTime(now: Date = new Date()): { date: string; time: string } {
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    date: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
    time: `${pad(now.getHours())}:${pad(now.getMinutes())}`,
  };
}

export function useAdminInboxQuery(schoolYearId: string | undefined) {
  const { date, time } = localDateAndTime();
  return useQuery(AdminInboxQuery, {
    variables: { schoolYearId: schoolYearId!, date, time },
    skip: !schoolYearId,
    fetchPolicy: 'cache-and-network',
  });
}
